import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

export const noResultsContainerCss: CSSObject = {
  display: "flex",
  gap: "20px",
  padding: "16px 24px",
  marginTop: "24px",
  minWidth: "288px",
  maxWidth: "450px",
  alignSelf: "center",
  borderRadius: "16px",
  background: constants.colors.ui.white[50],

  svg: {
    minWidth: "88px",
  },
};

export const noResultsTextContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  gap: "4px",
};

export const noResultsHeadingCss = {
  ...typographyStyles.fontSize.heading4,
  ...typographyStyles.fontFamily.circular,

  margin: 0,
};

export const noResultsParagraphCss = {
  ...typographyStyles.fontSize.heading5,
  ...typographyStyles.fontFamily.circular,

  margin: 0,
  fontWeight: 700,
};
